// Error messages
export const GENERIC_ERROR_MESSAGE = "An error occurred, please try again";
export const TIMEOUT_ERROR_MESSAGE =
  "I apologize, but I'm having trouble processing your request right now. This may be temporary - please try again in a few moments. If the issue continues, you may want to rephrase your question. Thank you for your patience!";
export const AUTH_ERROR_MESSAGE =
  "Access is currently limited due to allowed/restricted group restrictions set by the safer owner. Please contact the service owner via SIM ticketing (CTI: WorkingWell / WorkingWell Program / Engineering).";
